import Axios from 'axios'

export class ConfigAxios {
    constructor(app) {
        this.store = app.config.globalProperties.$store
        this.router = app.config.globalProperties.$router

        Axios.defaults.baseURL = getBack(process.env.NODE_ENV) + "/api";
        Axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
        Axios.defaults.headers.common['Access-Control-Expose-Headers'] = "Content-Length";
        Axios.defaults.headers.common["Access-Control-Allow-Credentials"] ="true";
        Axios.defaults.headers.common['charset'] = "utf-8";
        Axios.defaults.crossDomain = true;

        Axios.interceptors.request.use(
            config => {
                this.store.dispatch("atualizaState") //atualiza state com dados do navegador pra caso tenha feito logou e login em outra aba
                let usuario = this.store.getters.usuario
                if (this.store.getters.token)
                    config.headers.Authorization = `Bearer ${this.store.getters.token}`
                else
                    config.headers['tipo-dispositivo'] = usuario?.dispositivo || app.config.globalProperties.$vistra.getDispositivo()
                return config
            },
            error => {
                return Promise.reject(error)
            }
        );

        Axios.interceptors.response.use(async response => {
            if (response.config.url.toLocaleLowerCase() == '/usuario/refreshtoken') {
                if (response.data.token) {
                    if (response.data.token != app.config.globalProperties.$vistra.Contexto.getToken()) {
                        this.store.dispatch('updateToken', response.data.token)
                        let usuario = { ...response.data.usuario, ...response.data.dispositivo }
                        if (this.store.state.integracao) //se for integração mantém,0
                            usuario.modoEscuro = this.store.state.usuario.modoEscuro
                        this.store.dispatch('setDadosUsuario', usuario)
                        this.store.state.msgSistema = response.data.msgSistema
                        if (window.isDebug) {
                            console.nice(`$HTTP: Token renovado ${(new Date()).toLocaleString()} - ${response.data.token.split('.').at(-1)}`);
                        }
                    }
                }
            }

            if (!this.store.getters.integracao && localStorage.getItem('usuario') == null && localStorage.getItem('resetarSenha') == null) {
                this.logout(); 
            }

            this.erroDeConexao = false
            return response;
        }, async error => {
            if (error.response) {
                switch (error.response.status) {
                    case 419: //Status419AuthenticationTimeout
                        let requisicaoOriginal = error.config
                        let token = error.response.data.token;
                        if (token) {
                            requisicaoOriginal.headers['Authorization'] = 'Bearer ' + token;
                            if (token != app.config.globalProperties.$vistra.Contexto.getToken()) {
                                this.store.dispatch('updateToken', token)
                                let usuario = { ...error.response.data.usuario, ...error.response.data.dispositivo }
                                if (this.store.state.integracao) //se for integração mantém
                                    usuario.modoEscuro = this.store.state.usuario.modoEscuro
                                this.store.dispatch('setDadosUsuario', usuario)
                                this.store.state.msgSistema = error.response.data.msgSistema
                                if (window.isDebug) {
                                    console.nice(`$HTTP: Token renovado ${(new Date()).toLocaleString()} - ${token.split('.').at(-1)}`);
                                }
                            }

                            return Axios(requisicaoOriginal)
                        } else {
                            this.store.state.msgSistema = error.response.data.msg
                            this.logout(); 
                        }
                        break;
                    case 401: //Acesso negado
                        if (error.response?.data?.msg) {
                            app.config.globalProperties.$vistra.showMessage(error.response.data.msg, "info", {
                                displayTime: 5000000
                            })
                        }
                        if (error.config.url.toLowerCase().startsWith('/usuario/alteraempresacontexto'))
                            return //não faz logout se tava tentando mudar de empresa do contexto
                        this.logout(); 
                        return
                }
            }
            else {
                //tratamento de erro de conexão
                if (!this.erroDeConexao) {
                    if (this.store.getters.isOnline) {
                        this.erroDeConexao = true
                        setTimeout(() => { // espera pra não piscar a tela caso o erro já não aconteça na próxima chamada imediata
                            if (this.erroDeConexao) {
                                // substituído popup acima por somente uma mensagem de aviso    !!!                    
                                app.config.globalProperties.$vistra.showMessage(app.config.globalProperties.$vistra.globalize("msg-erro-falha-conexao"), "warning")
                                this.erroDeConexao = false

                            } else {
                                console.show("Mensagem não apareceu graças à espera de 3 segundos pra ver se tá com problema mesmo")
                            }
                        }, 3000);
                    }
                    else {
                        app.config.globalProperties.$vistra.showMessage(app.config.globalProperties.$vistra.globalize("app-offline"), "warning")
                    }
                }
            }
            return Promise.reject(error.response || error);
        });
        app.config.globalProperties.$http = Axios;
        
        if (window.isDebug)
            console.log('Caminho da API:', Axios.defaults.baseURL)
    }

    logout() {
        this.store
            .dispatch("logout", {})
            .then(() => {
                if (!this.router.currentRoute.value.meta || !this.router.currentRoute.value.meta.requiresAuth)
                    return;
                if (this.store.getters.integracao && !this.store.getters.permissaoSistemaCompletoIntegracao)
                    this.router.push({name: 'integracao-offline'})
                else if (this.router.currentRoute.value.name != 'login')
                    this.store.dispatch("setPermissaoSistemaCompletoIntegracao", false)
                    this.router.push({name: 'login', url: document.URL})
            })
    }
}